export default __webpack_public_path__ + "c7610b75437dc99a8a2235b0ced2187c.svg";